import { render, staticRenderFns } from "./BankCellSkeleton.vue?vue&type=template&id=ca359dec&lang=pug"
import script from "./BankCellSkeleton.vue?vue&type=script&lang=ts"
export * from "./BankCellSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./BankCell.module.scss?vue&type=style&index=0&prod&module=true&lang=scss&external"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports